import { IRootState } from '../../../store'
import { IPaymentInformationState } from '../store/paymentInformation.types'

export const getPaymentInformationSelector = (state: IRootState): IPaymentInformationState => state.paymentInformation
